export const memberListInitialState = {
    membersIds: [],
};
export const memberListReducer = (state = memberListInitialState, action) => {
    switch (action.type) {
        case "initialize":
            return Object.assign(Object.assign({}, state), { membersIds: action.membersIds });
        case "removeMembers":
            return Object.assign(Object.assign({}, state), { membersIds: state.membersIds.filter((m) => action.membersIds.find((id) => id !== m)) });
        case "addMembers": {
            return Object.assign(Object.assign({}, state), { membersIds: [...state.membersIds].concat(action.membersIds) });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map